export const BASE_10_SCORE = 10;

export const toBase10Score = (decimal) => decimal * BASE_10_SCORE;

export const formatPartialScore = (score, maxScore) => `${toBase10Score(score)}/${toBase10Score(maxScore)}`;

export const EVALUATION_SCALE = {
  NUMERIC: 'numeric',
  QUALITATIVE: 'qualitative',
};

export const isScaleNumeric = (scale) => {
  return scale?.type === EVALUATION_SCALE.NUMERIC;
};

export const isScaleQualitative = (scale) => {
  return scale?.type === EVALUATION_SCALE.QUALITATIVE;
};

// Función para convertir un valor del servidor (escala 0-10) a la escala original (min-max)
export const getOriginalScale = (serverValue, min, max, numberDecimals = 2) => {
  // Si no hay valor o no es un número, retornamos el valor por defecto
  if (serverValue === null || serverValue === undefined || serverValue === '' || isNaN(parseFloat(serverValue))) {
    return '-';
  }

  // Convertimos el valor a número
  const value = parseFloat(serverValue);

  // Fórmula inversa: min + (valor / 10) * (max - min)
  const originalValue = min + (value / 10) * (max - min);
  // Formatear el valor según el número de decimales especificado
  if (numberDecimals === 0) {
    // Si no se permiten decimales, devolver solo la parte entera
    return Math.round(originalValue).toString();
  } else {
    // Mostrar el número de decimales especificado
    const withDecimals = originalValue.toFixed(numberDecimals);

    // Eliminar los ceros a la derecha en la parte decimal
    const cleanedValue = parseFloat(withDecimals);

    return cleanedValue.toString();
  }
};

// Función para convertir un valor del servidor (escala 0-10) a la escala original (min-max)
export const getOriginalScaleQualitative = (evaluationScale, grade) => {
  return evaluationScale?.ranges && grade !== null && grade !== undefined
    ? evaluationScale.ranges.find((range) => {
        const gradeValue = grade * 10;
        // Si from es 100, permitimos que gradeValue sea igual a from
        if (range.from === 100) {
          return gradeValue >= range.to && gradeValue <= range.from;
        } else {
          return gradeValue >= range.to && gradeValue < range.from;
        }
      })?.name
    : '-';
};

// Función para convertir un valor de la escala original a (escala 0-10)
export const getPointsScale = (points, min, max) => {
  // Si no hay valor o el valor no es un número, retornamos null
  if (points === null || points === undefined || points === '' || isNaN(parseFloat(points))) {
    return null;
  }

  // Convertimos el valor a número
  const value = parseFloat(points);

  // Si el valor está fuera del rango permitido, lo limitamos
  if (value < min) return 0;
  if (value > max) return 10;

  // Normalizamos el valor a una escala de 0-10
  // Fórmula: (valor - valorMínimo) / (valorMáximo - valorMínimo) * 10

  return ((value - min) / (max - min)) * 10;
};
